import { render, staticRenderFns } from "./ChangeConfigurationOrderView.vue?vue&type=template&id=5dcc8b2a"
import script from "./ChangeConfigurationOrderView.vue?vue&type=script&lang=js"
export * from "./ChangeConfigurationOrderView.vue?vue&type=script&lang=js"
import style0 from "./ChangeConfigurationOrderView.vue?vue&type=style&index=0&id=5dcc8b2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports